<app-header title="self-serve.payrollDocuments.supportingDocuments"></app-header>
<p class="text-color-secondary-font margin-bottom-6">
    {{ 'self-serve.payrollDocuments.supportingDocumentsExplanation' | translate }}
</p>

<ui-banner *ngIf="!isPayrollSyncEnabled" class="margin-bottom-4" variant="info">{{
    'self-serve.payrollDocuments.ableToSubmitAfter' | translate
}}</ui-banner>

<div [class.loading]="isLoading" class="loadable">
    <div class="margin-bottom-4 text-color-secondary-font" *ngFor="let document of documents">
        <h3>
            {{ document.title | translate }} &nbsp;
            <ui-badge *ngIf="document.status === 'ready_for_review'" type="warning"
                >{{ 'self-serve.payrollDocuments.inReview' | translate }}
            </ui-badge>
            <ui-badge *ngIf="document.status === 'rejected'" type="danger"
                >{{ 'self-serve.payrollDocuments.rejected' | translate }}
            </ui-badge>
            <ui-badge *ngIf="document.status === 'verified'" type="success"
                >{{ 'self-serve.payrollDocuments.approved' | translate }}
            </ui-badge>
        </h3>
        <p>{{ document.description | translate }}</p>
        <ui-banner class="margin-bottom-4" *ngIf="document.rejectionMessage" variant="danger">{{
            document.rejectionMessage
        }}</ui-banner>
    </div>

    <div *ngIf="isPayrollSyncEnabled" class="flex buttons justify-end">
        <ui-button (click)="trackSelfServePayrollUploadDocuments()" type="primary">{{
            (isAllUploaded
                ? 'self-serve.payrollDocuments.viewDocumentsInPayroll'
                : 'self-serve.payrollDocuments.uploadDocumentsInPayroll'
            ) | translate
        }}</ui-button>
    </div>
</div>
